<template>
    <div class="-m-5 md:m-0 h-full flex-1 overflow-hidden">
        <tabulator
            :columns="columns"
            :actions="actions"
            :refresh.sync="refreshTable"
            :loading="tableIsLoading"
            :loading-text="tableLoadingText"
            ajax-path="rhipe/products"
        />
    </div>
</template>

<script>
    import Http from '@/helpers/Http';

    export default {
        data() {
            return {
                refreshTable: false,
                tableIsLoading: false,
                tableLoadingText: null,
                columns: [
                    {
                        title: 'Name',
                        field: 'ProductName',
                        sorter: 'string',
                        minWidth: 200,
                    },
                    {
                        title: 'SKU',
                        field: 'ProductSku',
                        sorter: 'string',
                        minWidth: 200,
                    },
                    {
                        title: 'Frequency',
                        field: 'ProductFrequencies',
                        sorter: 'string',
                        minWidth: 100,
                    },
                    {
                        title: 'Unit',
                        field: 'ProductUnit',
                        sorter: 'string',
                        minWidth: 100,
                    },
                    {
                        title: 'Retail Price',
                        field: 'RetailPriceForHuman',
                        sorter: 'string',
                        minWidth: 100,
                    },
                ],
                actions: [
                    {
                        label: 'Sync',
                        icon: () => import('@/icons/Sync.vue'),
                        handler: this.sync
                    },
                ],
            }
        },
        methods: {
            sync() {
                this.tableIsLoading = true;
                this.tableLoadingText = 'Syncing...';
                Http.patch('rhipe/products/sync')
                    .then(() => {
                        this.tableIsLoading = false;
                        this.refreshTable = true;
                    })
                    .catch(() => {
                        this.tableIsLoading = false;
                    });
            }
        }
    }
</script>